import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import ProductLinkButton from "./ProductLinkButton";

export default function CouponCode({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "couponCode";
  const sectionTitle =
    "Coupon Code: Design discount terms and create coupon codes to reduce application fees";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.couponCode;
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        // ...
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />
      {productModulesGroup?.includes("product-agency") && (
        <>
          <Box
            sx={{
              padding: "10px",
              height: "calc(100vh - 255px)",
              overflowY: "auto",
              // background: "yellow",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ProductLinkButton title="Coupon Codes" href="/couponcodes" />
              </Grid>
            </Grid>
          </Box>
          {/* Form Actions */}
        </>
      )}
    </SectionStyled>
  );
}
